import React, { useEffect, useState } from "react";
import styles from "./MobileNumber.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyPhoneNumber } from "@services/authenticationService";
import { setComponentToShow } from "@store/ModalToShow";
import { setMobileNumber, setIsdCode } from "@store/login/loginStore";
import { useDispatch } from "react-redux";

const MobileNumber = () => {
  const dispatch = useDispatch();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91");

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/\D/g, ""); // prevents alphabets
    setPhoneNumber(value);
    dispatch(setIsdCode(countryCode));
    dispatch(setMobileNumber(value));
    localStorage.setItem("phoneNumber", value);
    localStorage.setItem("countryCode", countryCode);
    localStorage.setItem(
      "phoneData",
      JSON.stringify({ dialCode: countryCode, number: value })
    );
  };

  const handleStartClick = async () => {
    const phoneDataFromStorage = localStorage.getItem("phoneData");
    if (!phoneDataFromStorage) return;

    const res = await verifyPhoneNumber(JSON.parse(phoneDataFromStorage));
    if (res.existingUser) {
      dispatch(setComponentToShow("SendOtp"));
    } else {
      alert("Not an existing user");
    }
  };

  return (
    <div className={styles.mobile_input_container}>
      <div className={styles.input_group}>
        <select
          value={countryCode}
          className={styles.dial_code_select}
          onChange={(e) => setCountryCode(e.target.value)}
        >
          <option value="+91">+91</option>
          <option value="+1">+1</option>
        </select>

        <input
          type="tel"
          className={styles.mobile_number_input}
          placeholder="Enter your mobile number"
          onChange={handlePhoneChange}
          value={phoneNumber}
          maxLength={10}
        />

        <button
          type="button"
          className={styles.btn_primary}
          disabled={phoneNumber.length !== 10}
          onClick={handleStartClick}
        >
          START
        </button>
      </div>
    </div>
  );
};

export default MobileNumber;
